import { render, staticRenderFns } from "./KBSwitch.vue?vue&type=template&id=1907221f&scoped=true&"
import script from "./KBSwitch.vue?vue&type=script&lang=ts&"
export * from "./KBSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./KBSwitch.vue?vue&type=style&index=0&id=1907221f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907221f",
  null
  
)

export default component.exports